import {
  Contracts,
  getContractAddressesForChainOrThrow
} from '@injectivelabs/contracts'
import { TESTNET_CHAIN_ID } from '../utils/constants'
import { getWeb3Strategy } from '../web3'

let contracts: Contracts
export const getTestnetContracts = (): Contracts => {
  if (!contracts) {
    contracts = new Contracts({
      web3Strategy: getWeb3Strategy(),
      contractAddresses: getContractAddressesForChainOrThrow(TESTNET_CHAIN_ID),
      chainId: TESTNET_CHAIN_ID
    })
  }

  return contracts
}
